import { Routes as FleetWarehouseRoutes } from "ui/modules/fleet/warehouses/navigation";

import { Breadcrumb } from "ui/components/Breadcrumb";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";

import { useNavigate, useParams } from "react-router-dom";
import {
  FLEET_WAREHOUSE_DETAIL_PAGE_TITLE,
} from "ui/components/PageTitle/consts";
import WarehouseDetailCard from "./components/WarehouseDetailCard/WarehouseDetailCard";
// import TabMenu from "../components/TabMenu/TabMenu";
import { WarehouseDetailPageCmp, WarehouseDetailPageProps } from "./types";
import { useCallback, useEffect, useState } from "react";
import { transformRoute, useTranslate } from "helpers";
import { FleetWarehouseDetailFormValues } from "services/api/fleet/warehouses/types";
import { initialFleetWarehouseDetailForm } from "services/api/fleet/warehouses/consts";
import { Errors } from "services/forms/validation/types";
import { getFleetWarehouseAPI } from "services/api/fleet/warehouses/api";
import { SIDEBAR_ITEM_FLEET_WAREHOUSE_SEARCH } from "app/components/Sidebar/consts";
import { BreadcrumbItem } from "ui/components/Breadcrumb/types";
import WarehouseEditCard from "./components/WarehouseDetailCard/components/WarehouseEditCard/WarehouseEditCard";
import { Button } from "ui/components/Button/Button";
import { Routes } from "ui/modules/fleet/warehouses/navigation";
import WarehouseDeleteCard from "./components/WarehouseDetailCard/components/WarehouseDeleteCard/WarehouseDeleteCard";
import { Loader } from "ui/components/Loader";
import TabMenu from "../components/TabMenu/TabMenu";

const WarehouseDetailPage: WarehouseDetailPageCmp = (
  props: WarehouseDetailPageProps
) => {
  const { id } = useParams();

  const { t } = useTranslate();

  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showAddNewModal, setShowAddNewModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showAddWidgetModal, setShowAddWidgetModal] = useState<boolean>(false);

  const [formValues, setFormValues] = useState<FleetWarehouseDetailFormValues>(
    initialFleetWarehouseDetailForm
  );

  const navigate = useNavigate();

  const title = FLEET_WAREHOUSE_DETAIL_PAGE_TITLE;

  useEffect(() => {
    if (id) fetchWarehouse(id);
  }, [id]);

  const fetchWarehouse = async (id: string) => {
    if (id === undefined) {
      setFormValues(initialFleetWarehouseDetailForm);
      return;
    }

    setIsLoading(true);

    let result;
    try {
      result = await getFleetWarehouseAPI(id);

      if (result) setFormValues(result);
    } catch {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    setErrors({});
  };

  const handleEditSuccess = useCallback(() => {
    if (id) fetchWarehouse(id);
    setShowAddNewModal(false);
  }, []);

  const breadcrumbs: BreadcrumbItem[] = [
    {
      text: SIDEBAR_ITEM_FLEET_WAREHOUSE_SEARCH.text,
      route: SIDEBAR_ITEM_FLEET_WAREHOUSE_SEARCH.route,
    },
  ];

  const handleDeleteSuccess = useCallback(() => {
    navigate(transformRoute(Routes.FleetWarehouseSearchPageRouter, {}));
  }, []);

  if (!id) return <></>;

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md">
          <PageHeader>
            <div className="flex items-center justify-between w-full">
              <div>
                <PageTitle
                  title={`${t(title.text)} [${formValues.name ?? ""}]`}
                  icon={title.icon}
                  iconColor={title.iconColor}
                />
                <Breadcrumb items={breadcrumbs} />
              </div>
              <div className="flex items-center gap-2">
                <Button
                  variant="primary"
                  startIcon="/media/icons/plus.svg"
                  onClick={() => setShowAddNewModal(true)}
                >
                  Promjeni
                </Button>
                <Button
                  variant="remove"
                  startIcon="/media/icons/trash.svg"
                  onClick={() => setShowDeleteModal(true)}
                >
                  Obriši
                </Button>
                <Button
                  variant="secondary"
                  startIcon="/media/icons/setting.svg"
                  onClick={() => setShowAddWidgetModal(true)}
                />
              </div>
            </div>
          </PageHeader>
          <TabMenu warehouseId={id} />
        </div>
        <div className="px-0 py-6 mx-[-1px] xl:px-6">
          {isLoading ? (
            <Loader isLoading={true}>{null}</Loader>
          ) : (
            <WarehouseDetailCard
              fleetWarehouseDetail={formValues}
              showAddWidgetModal={showAddWidgetModal}
              setShowAddWidgetModal={setShowAddWidgetModal}
            />
          )}
        </div>
      </div>
      <WarehouseEditCard
        warehouseId={id ?? null}
        show={showAddNewModal}
        onClose={() => setShowAddNewModal(false)}
        onSuccess={handleEditSuccess}
      />
      <WarehouseDeleteCard
        warehouseId={id ?? null}
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onSuccess={handleDeleteSuccess}
      />
    </>
  );
};

WarehouseDetailPage.route = FleetWarehouseRoutes.FleetWarehouseDetailPageRouter;

export default WarehouseDetailPage;
